import React, { useState, useEffect } from 'react';

import './Popup.css';

const Popup = ({ isVisible, onClose, deal }) => {
    const [isClosing, setIsClosing] = useState(false);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
            setIsClosing(false);
        }, 400);
    };

    useEffect(() => {
        if (isVisible) setIsClosing(false);
    }, [isVisible]);

    if ((!isVisible && !isClosing) || !deal) {
        return null;
    }

    return (
        <div className={`popup-overlay ${isClosing ? 'closing' : ''}`}>
            <button className="close-button" onClick={handleClose}>&times;</button>

            <div className={`popup-content ${isClosing ? 'closing' : ''}`}>
                <p className="deal-text-popup">DECEMBER DEAL</p>
                <h1 className="main-title-popup">{deal.title}</h1>
                <img src={deal.qrImage} alt="QR Code" className="qr-code-image" />
                <p className="scan-text">Scan de QR-code bij de kassa, <br/> Drive of kiosk.</p>
            </div>
        </div>
    );
};

export default Popup;



// WEBPACK FOOTER //
// ./src/components/Popup.js